import styles from "./ErrorBoundary.module.css";
import React from 'react';
import { withRouter } from "next/router";

export default withRouter(class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props)
  
      // Define a state variable to track whether is an error or not
      this.state = { hasError: false }
    }
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI
  
      return { hasError: true }
    }
    componentDidCatch(error, errorInfo) {
        window.Bugsnag?.notify(error, function (event) {
            event.context = 'fallback'
          })
      console.log({ error, errorInfo })
    }
    render() {
      // Check if the error is thrown
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <div className={styles.Error}>
            <hr className={styles.Error__Bar}></hr>
            <h1>Loading Fail</h1>
            <p className={styles.Error__Message}>Oops, something went wrong with your menu! Please try again.</p>
            <button
              type="button"
              className={styles.Error__Reload}
              onClick={() => this.props.router.push({
                pathname: this.props.router.query?.entrypoint && this.props.router.query?.entrypoint === "ingamemenu" ? "/menu" : "/menu",
                query: { ...this.props.router.query, transition: 1 },
              })} // or send to unity
            //   onClick={() => this.setState({ hasError: false })}
            >
              Back to Home
            </button>
            <hr className={styles.Error__Bar}></hr>
          </div>
        )
      }
  
      // Return children components in case of no error
  
      return this.props.children
    }
  })